var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponsivePlataformaIndustriaCircular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-responsive-plataforma-industria-circular"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "responsive-plataforma-industria-circular",
    clipPath: "url(#clip-responsive-plataforma-industria-circular)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75",
    transform: "translate(-166.833 -593.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_262",
    "data-name": "Trazado 262",
    d: "M167.883,621.207a30.325,30.325,0,0,1,.748-6.842,26.4,26.4,0,0,1,18.6-18.174c1.23-.322,13.21-3.238,23.2,5.025a25.9,25.9,0,0,1,9.087,23.626c-1.48,8.961-8.337,15.286-8.66,15.288-.481,0,1.222-1.976,2.459-5.238a29.355,29.355,0,0,0,1.575-12.771,22.548,22.548,0,0,0-14.831-18.339,23.911,23.911,0,0,0-16.143-.107,22.881,22.881,0,0,0-10.691,8.018,58.29,58.29,0,0,0-5.345,9.515",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    "data-name": "Trazado 263",
    d: "M354.949,743.687c-.035.17,1.711.517,3.742,1.283a19.14,19.14,0,0,1,8.751,7.671,16.658,16.658,0,0,1,2.474,8.686,17.6,17.6,0,0,1-1.5,9.211,18.081,18.081,0,0,1-5.962,7.4c-5.586,4.436-12.731,4.009-14.7,3.6-5.155-1.068-7.334-3.762-7.557-3.379s2.612,2.893,6.113,4.643a20.3,20.3,0,0,0,13.756,1.344,20.594,20.594,0,0,0,15.569-19.128,20,20,0,0,0-4.123-13.2,19.642,19.642,0,0,0-10.8-7.377c-2.743-.718-5.728-.965-5.773-.748",
    transform: "translate(-161.943 -139.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M239.293,851.384c.222.128-1.368,2.148-2.031,4.383-.31,1.045-1.176,3.368-.535,8.339a15.134,15.134,0,0,0,4.7,8.766c.654.617,5.57,5.308,12.722,4.49a17.832,17.832,0,0,0,11.225-6.2c2.321-2.666,2.606-6.28,2.931-6.174.293.1-.144,2.526-.958,4.916a16.953,16.953,0,0,1-4.832,7.229,16.585,16.585,0,0,1-8.256,4.082,18.832,18.832,0,0,1-6.533,0,16.414,16.414,0,0,1-7.226-3.236,17.065,17.065,0,0,1-6.477-16.825,20.376,20.376,0,0,1,1.951-5.813c1.021-1.943,3.072-4.095,3.314-3.956",
    transform: "translate(-61.895 -240.547)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsivePlataformaIndustriaCircular);
export default __webpack_public_path__ + "static/media/responsive-plataforma-industria-circular.baaeff371aecdaedb907fbedddeb1254.svg";
export { ForwardRef as ReactComponent };